module.exports = __webpack_public_path__ + "img/pic_sx.0c239838.png";